import type { ReactNode } from 'react';
import { Sidebar } from './Sidebar';
import styles from './Layout.module.css';

interface LayoutProps {
  children: ReactNode;
  customerName?: string;
  onSignOut: () => void;
}

export function Layout({ children, customerName, onSignOut }: LayoutProps) {
  return (
    <div className={styles.layout}>
      <Sidebar customerName={customerName} onSignOut={onSignOut} />
      <main className={styles.main}>
        {children}
      </main>
    </div>
  );
}
